window.Cache = function () {
  this.store = function (key, value, durationDays, durationHours, durationMinutes) {
    if (window.localStorage && window.globalObject.flags.localStorageAvailable) {
      let durationInDays = 14; // default is 2 weeks.
      if (durationDays) {
        durationInDays = durationDays;
      }
      const today = new Date();
      let expiryDate = today.setDate(today.getDate() + durationInDays);

      if (durationHours) {
        expiryDate = today.setHours(today.getHours() + durationHours);
      }

      if (durationMinutes) {
        expiryDate = today.setMinutes(today.getMinutes() + durationMinutes);
      }

      const object = {
        value,
        timestamp: today.getTime(),
        expiryDate,
      };
      localStorage.setItem(key, JSON.stringify(object));
    }
  };

  this.read = function (key) {
    // return null; //cache disabled for testing

    let result = null;
    if (window.localStorage) {
      result = JSON.parse(localStorage.getItem(key));
      if (result && result.value) {
        // check expirt
        const today = new Date().getTime();
        if (today < result.expiryDate) {
          return result.value;
        }

        return null;
      }

      return result;
    }
    return result;
  };

  this.removeLike = function (key) {
    let index = 0;
    let item;
    let storageLength;

    if (window.localStorage) {
      storageLength = window.localStorage.length;

      for (index; index < storageLength; ++index) {
        item = window.localStorage.key(index);

        if (item !== null && item !== undefined && item.match(key)) {
          window.localStorage.removeItem(item);
        }
      }
    }
  };

  this.remove = function (key) {
    if (window.localStorage) {
      if (localStorage.getItem(key)) {
        window.localStorage.removeItem(key);
        return true;
      }

      return false;
    }

    return false;
  };
};
